webpackJsonp([57],{

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(54).f;
var create = __webpack_require__(240);
var redefineAll = __webpack_require__(247);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(246);
var forOf = __webpack_require__(239);
var $iterDefine = __webpack_require__(150);
var step = __webpack_require__(251);
var setSpecies = __webpack_require__(252);
var DESCRIPTORS = __webpack_require__(40);
var fastKey = __webpack_require__(1353).fastKey;
var validate = __webpack_require__(1387);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(28);
var meta = __webpack_require__(1353);
var fails = __webpack_require__(76);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(247);
var forOf = __webpack_require__(239);
var anInstance = __webpack_require__(246);
var isObject = __webpack_require__(55);
var setToStringTag = __webpack_require__(105);
var dP = __webpack_require__(54).f;
var each = __webpack_require__(1422)(0);
var DESCRIPTORS = __webpack_require__(40);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(149);
var toObject = __webpack_require__(78);
var toLength = __webpack_require__(106);
var asc = __webpack_require__(1423);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1424);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
var isArray = __webpack_require__(1356);
var SPECIES = __webpack_require__(22)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(146);
var from = __webpack_require__(1426);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(239);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);
var aFunction = __webpack_require__(80);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(239);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1450), __esModule: true };

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(241);
__webpack_require__(143);
__webpack_require__(234);
__webpack_require__(1451);
__webpack_require__(1452);
__webpack_require__(1453);
__webpack_require__(1454);
module.exports = __webpack_require__(12).Set;


/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1420);
var validate = __webpack_require__(1387);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1421)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(28);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1425)('Set') });


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1427)('Set');


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1428)('Set');


/***/ }),

/***/ 2707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var emptyGroupMarketForm = function emptyGroupMarketForm() {
  return {
    id: null,
    sales_id: null,
    market_id: null,
    sales_name: '',
    market_name: null,
    sales_id2: null,
    sales_name2: '',
    sales_id3: null,
    sales_name3: '',
    sales_id4: null,
    sales_name4: '',
    sales_id5: null,
    sales_name5: ''
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */]],
  data: function data() {
    return {
      showCreateGroupMarketDialog: false,
      createDialog: {
        title: null,
        action: null
      },
      createForm: emptyGroupMarketForm(),
      tempGroupMarket: emptyGroupMarketForm(),
      customerLoading: false,
      customer: {
        id: null,
        name: '',
        number: ''
      },
      createFormRules: {
        sales_name: [{ required: true, message: '请输入群组名称', trigger: 'blur' }],
        market_id: [{ required: true, message: '请选择门店', trigger: 'blur' }]
      },
      search: {
        customer_id: this.$route.params.customerid,
        projectid: this.$route.params.projectid ? String(this.$route.params.projectid) : '',
        market_id: this.$route.query.market_id,
        group: this.$route.query.group
      },
      searchFieldType: {
        customer_id: Number,
        projectid: Number,
        market_id: Number
      },
      exportHeader: [{
        key: 'market_id',
        text: '门店ID'
      }, {
        key: 'market_name',
        text: '门店名称'
      }, {
        key: 'sales_name',
        text: '群组名称1'
      }, {
        key: 'sales_name2',
        text: '群组名称2'
      }, {
        key: 'sales_name3',
        text: '群组名称3'
      }, {
        key: 'sales_name4',
        text: '群组名称4'
      }, {
        key: 'sales_name5',
        text: '群组名称5'
      }, {
        key: 'created_at',
        text: '创建时间'
      }, {
        key: 'updated_at',
        text: '更新时间'
      }]
    };
  },
  created: function created() {
    this.loadCustomer();
  },

  watch: {
    '$route.params.customerid': function $routeParamsCustomerid() {
      this.syncRouteScope();
    },
    '$route.params.projectid': function $routeParamsProjectid() {
      this.syncRouteScope();
    }
  },
  computed: {
    isProjectLevel: function isProjectLevel() {
      return !!this.$route.params.projectid;
    },
    marketUploadPath: function marketUploadPath() {
      if (this.isProjectLevel) {
        return '/group-batch/market-upload-table/' + this.search.customer_id + '/project/' + this.search.projectid;
      }
      return '/group-batch/market-upload-table/' + this.search.customer_id;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request.map(['getBasicMarketTable', 'getBasicMarketDetail', 'getBasicCustomerDetail', 'getProjectDetail', 'getBaiscProjectTable']), {
    normalizeProjectId: function normalizeProjectId(item) {
      if (item && item.id != null) {
        item.id = String(item.id);
      }
      return item;
    },
    queryProjectForSelect: function queryProjectForSelect(params) {
      var _this = this;

      return this.getBaiscProjectTable(params).then(function (res) {
        var list = res.data && res.data.data;
        if (Array.isArray(list)) {
          list.forEach(function (item) {
            return _this.normalizeProjectId(item);
          });
        }
        return res;
      });
    },
    findProjectForSelect: function findProjectForSelect(params) {
      var _this2 = this;

      return this.getProjectDetail({ id: params.id }).then(function (res) {
        if (res.data) {
          _this2.normalizeProjectId(res.data);
        }
        return res;
      });
    },
    syncRouteScope: function syncRouteScope() {
      this.search.customer_id = this.$route.params.customerid;
      this.search.projectid = this.$route.params.projectid ? String(this.$route.params.projectid) : '';
      this.loadCustomer();
      this.onSearch();
    },
    onProjectChange: function onProjectChange() {
      var projectId = this.search.projectid ? String(this.search.projectid) : '';
      var routeProjectId = this.$route.params.projectid ? String(this.$route.params.projectid) : '';
      if (!projectId) {
        this.search.projectid = routeProjectId;
        return;
      }
      if (projectId === routeProjectId) {
        return;
      }
      this.$router.push('/group-batch/market-table/' + this.search.customer_id + '/project/' + projectId);
    },
    loadCustomer: function loadCustomer() {
      var _this3 = this;

      var id = this.$route.params.customerid;
      if (!id) {
        return;
      }
      this.customerLoading = true;
      request.common('getBasicCustomerDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this3.customer = {
          id: data.id,
          name: data.name,
          number: data.number
        };
      }).catch(function () {
        _this3.customer = {
          id: id,
          name: '客户信息加载失败',
          number: ''
        };
      }).then(function () {
        _this3.customerLoading = false;
      });
    },
    getTableData: function getTableData(params) {
      return request.page('getGroupMarketTable', filter.copyJson(params));
    },
    submitForm: function submitForm(formName, action) {
      var _this4 = this;

      var apiName = this.createDialog.action === 1 ? 'createGroupMarket' : 'updateGroupMarket';
      var actionName = this.createDialog.action === 1 ? '新增' : '更新';
      var self = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var names = [self.createForm.sales_name, self.createForm.sales_name2, self.createForm.sales_name3, self.createForm.sales_name4, self.createForm.sales_name5].map(function (n) {
            return (n || '').trim();
          }).filter(Boolean);
          if (names.length !== new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(names).size) {
            self.$message.error('群组名称不能重复');
            return;
          }

          var requestData = {
            market: self.createForm.market_id,
            group: self.createForm.sales_name,
            group2: self.createForm.sales_name2,
            group3: self.createForm.sales_name3,
            group4: self.createForm.sales_name4,
            group5: self.createForm.sales_name5,
            customer_id: _this4.search.customer_id,
            projectid: Number(_this4.search.projectid) || 0
          };

          if (self.createForm.id) {
            requestData['id'] = self.createForm.id;
          }

          request.common(apiName, requestData).then(function (result) {
            self.showCreateGroupMarketDialog = false;
            self.createForm = emptyGroupMarketForm();
            self.tempGroupMarket = emptyGroupMarketForm();
            self.$message.success(actionName + '成功');
            self.onSearch();
          });
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.createForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.tempGroupMarket);
    },
    displayCreateMarketGroupDialog: function displayCreateMarketGroupDialog(obj) {
      if (!obj) {
        this.createDialog.title = '新增群组门店关系';
        this.createDialog.action = 1;
        this.createForm = emptyGroupMarketForm();
        this.tempGroupMarket = emptyGroupMarketForm();
      } else {
        var formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(emptyGroupMarketForm(), obj);

        this.searchMarketResults = [{
          market_id: formData.market_id,
          marketname: formData.market_name
        }];

        this.createDialog.title = '编辑群组门店关系';
        this.createDialog.action = 2;
        this.createForm = formData;
        this.tempGroupMarket = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.createForm);
      }
      this.showCreateGroupMarketDialog = true;
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search
      });
    },
    onCloseCreateGroupMarketDialog: function onCloseCreateGroupMarketDialog(done) {
      if (this.createDialog.action === 2) {
        this.tempGroupMarket = emptyGroupMarketForm();
        this.resetForm('createForm');
      } else {
        this.tempGroupMarket = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.createForm);
      }
      done();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBatchRemoveBtnClicked: function handleBatchRemoveBtnClicked() {
      var _this5 = this;

      var scopeLabel = this.isProjectLevel ? '当前项目' : '客户级';
      this.$confirm('\u672C\u6B21\u6E05\u7406' + scopeLabel + '\u95E8\u5E97\u5173\u7CFB\u5171' + this.pagination.total + '\u6761\uFF0C\u786E\u8BA4\u6E05\u7406\u5417\uFF1F', '提示', {
        type: 'warning'
      }).then(function () {
        request.common('deleteGroupBatchByCustomerId', {
          customer_id: _this5.$route.params.customerid,
          projectid: Number(_this5.search.projectid) || 0
        }).then(function () {
          _this5.onRefresh();
        });
      });
    }
  })
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchMarketTable_vue__ = __webpack_require__(2707);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a88b14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchMarketTable_vue__ = __webpack_require__(4118);
function injectStyle (ssrContext) {
  __webpack_require__(4114)
  __webpack_require__(4116)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62a88b14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchMarketTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a88b14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchMarketTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4114:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("22849c68", content, true, {});

/***/ }),

/***/ 4115:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-table-column--selection .cell{padding-left:10px!important}", "", {"version":3,"sources":["/workspace/src/views/group-batch/pages/GroupBatchMarketTable.vue"],"names":[],"mappings":"AACA,kCAAkC,2BAA4B,CAC7D","file":"GroupBatchMarketTable.vue","sourcesContent":["\n.el-table-column--selection .cell{padding-left:10px !important\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4116:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4117);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4088c7ec", content, true, {});

/***/ }),

/***/ 4117:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".customer-context[data-v-62a88b14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px 24px;margin:0 0 16px;padding:14px 18px;background:#f7f8fa;border:1px solid #ebeef5;border-left:3px solid #409eff;border-radius:4px;min-height:52px;-webkit-box-sizing:border-box;box-sizing:border-box}.customer-context__main[data-v-62a88b14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;gap:10px;min-width:0}.customer-context__label[data-v-62a88b14]{-ms-flex-negative:0;flex-shrink:0;font-size:12px;color:#909399;letter-spacing:.02em}.customer-context__name[data-v-62a88b14]{font-size:16px;font-weight:600;color:#303133;line-height:1.3;word-break:break-all}.customer-context__meta[data-v-62a88b14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;-ms-flex-negative:0;flex-shrink:0}.customer-context__meta-item[data-v-62a88b14]{font-size:13px;color:#606266;font-variant-numeric:tabular-nums}.customer-context__meta-item em[data-v-62a88b14]{font-style:normal;margin-right:6px;color:#909399;font-size:12px}.customer-context__divider[data-v-62a88b14]{width:1px;height:12px;background:#dcdfe6}", "", {"version":3,"sources":["/workspace/src/views/group-batch/pages/GroupBatchMarketTable.vue"],"names":[],"mappings":"AACA,mCAAmC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,mBAAmB,eAAe,aAAa,gBAAgB,kBAAkB,mBAAmB,yBAAyB,8BAA8B,kBAAkB,gBAAgB,8BAA8B,qBAAqB,CACtd,AACD,yCAAyC,oBAAoB,oBAAoB,aAAa,2BAA2B,wBAAwB,qBAAqB,SAAS,WAAW,CACzL,AACD,0CAA0C,oBAAoB,cAAc,eAAe,cAAc,oBAAqB,CAC7H,AACD,yCAAyC,eAAe,gBAAgB,cAAc,gBAAgB,oBAAoB,CACzH,AACD,yCAAyC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,oBAAoB,aAAa,CACzM,AACD,8CAA8C,eAAe,cAAc,iCAAiC,CAC3G,AACD,iDAAiD,kBAAkB,iBAAiB,cAAc,cAAc,CAC/G,AACD,4CAA4C,UAAU,YAAY,kBAAkB,CACnF","file":"GroupBatchMarketTable.vue","sourcesContent":["\n.customer-context[data-v-62a88b14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px 24px;margin:0 0 16px;padding:14px 18px;background:#f7f8fa;border:1px solid #ebeef5;border-left:3px solid #409eff;border-radius:4px;min-height:52px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.customer-context__main[data-v-62a88b14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;gap:10px;min-width:0\n}\n.customer-context__label[data-v-62a88b14]{-ms-flex-negative:0;flex-shrink:0;font-size:12px;color:#909399;letter-spacing:0.02em\n}\n.customer-context__name[data-v-62a88b14]{font-size:16px;font-weight:600;color:#303133;line-height:1.3;word-break:break-all\n}\n.customer-context__meta[data-v-62a88b14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;-ms-flex-negative:0;flex-shrink:0\n}\n.customer-context__meta-item[data-v-62a88b14]{font-size:13px;color:#606266;font-variant-numeric:tabular-nums\n}\n.customer-context__meta-item em[data-v-62a88b14]{font-style:normal;margin-right:6px;color:#909399;font-size:12px\n}\n.customer-context__divider[data-v-62a88b14]{width:1px;height:12px;background:#dcdfe6\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("群组控制")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.customerLoading),expression:"customerLoading"}],staticClass:"customer-context"},[_c('div',{staticClass:"customer-context__main"},[_c('span',{staticClass:"customer-context__label"},[_vm._v("当前客户")]),_vm._v(" "),_c('span',{staticClass:"customer-context__name"},[_vm._v(_vm._s(_vm.customer.name || '加载中…'))])]),_vm._v(" "),(_vm.customer.id)?_c('div',{staticClass:"customer-context__meta"},[_c('span',{staticClass:"customer-context__meta-item"},[_c('em',[_vm._v("编号")]),_vm._v(_vm._s(_vm.customer.number || '-')+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"customer-context__divider"}),_vm._v(" "),_c('span',{staticClass:"customer-context__meta-item"},[_c('em',[_vm._v("ID")]),_vm._v(_vm._s(_vm.customer.id)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"}},[_c('div',{staticClass:"re-el-form__flex"},[(_vm.isProjectLevel)?_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectid"}},[_c('remote-select',{attrs:{"id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目名称/编号搜索","query-request":_vm.queryProjectForSelect,"query-params":{customerid: _vm.search.customer_id},"find-request":_vm.findProjectForSelect},on:{"change":_vm.onProjectChange},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店名称/ID","prop":"market"}},[_c('remote-select',{attrs:{"label-key":"marketname","placeholder":"请输入门店名称搜索","query-request":_vm.getBasicMarketTable,"find-request":_vm.getBasicMarketDetail,"clearable":""},model:{value:(_vm.search.market_id),callback:function ($$v) {_vm.$set(_vm.search, "market_id", $$v)},expression:"search.market_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群组名称","prop":"group"}},[_c('el-input',{attrs:{"placeholder":"请输入群组名称","clearable":""},model:{value:(_vm.search.group),callback:function ($$v) {_vm.$set(_vm.search, "group", $$v)},expression:"search.group"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":function($event){return _vm.onSearch()}}},[_vm._v("搜索\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"size":"mini","type":"primary","icon":"el-icon-folder-add"},on:{"click":function($event){return _vm.displayCreateMarketGroupDialog(null)}}},[_vm._v(" 新增\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary","icon":"el-icon-download","disabled":_vm.pagination.total <= 0},on:{"click":_vm.onExportSearch}},[_vm._v(" 按搜索结果导出\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary","icon":"el-icon-upload"},on:{"click":function($event){return _vm.$router.push(_vm.marketUploadPath)}}},[_vm._v(" 批量上传\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"danger","icon":"el-icon-delete","disabled":_vm.pagination.total <= 0},on:{"click":_vm.handleBatchRemoveBtnClicked}},[_vm._v(" 批量清除全部\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table}},[_c('el-table-column',{attrs:{"prop":"market_name","label":"门店名称/ID","min-width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.market_name)+" / "+_vm._s(scope.row.market_id)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales_name","label":"群组名称1","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales_name2","label":"群组名称2","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales_name3","label":"群组名称3","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales_name4","label":"群组名称4","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales_name5","label":"群组名称5","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间","min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updated_at","label":"更新时间","min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"操作","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.displayCreateMarketGroupDialog(scope.row)}}},[_vm._v("编辑")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination margin t10"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[10, 20, 30, 50],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.createDialog.title,"before-close":_vm.onCloseCreateGroupMarketDialog,"visible":_vm.showCreateGroupMarketDialog},on:{"update:visible":function($event){_vm.showCreateGroupMarketDialog=$event}}},[_c('el-form',{ref:"createForm",attrs:{"model":_vm.createForm,"rules":_vm.createFormRules}},[_c('el-form-item',{attrs:{"label":"门店名称/ID","prop":"market_id","label-width":"120px"}},[_c('remote-select',{attrs:{"label-key":"marketname","placeholder":"请输入门店名称搜索","query-request":_vm.getBasicMarketTable,"find-request":_vm.getBasicMarketDetail,"clearable":""},model:{value:(_vm.createForm.market_id),callback:function ($$v) {_vm.$set(_vm.createForm, "market_id", $$v)},expression:"createForm.market_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群组名称1","prop":"sales_name","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"请输入","clearable":""},model:{value:(_vm.createForm.sales_name),callback:function ($$v) {_vm.$set(_vm.createForm, "sales_name", $$v)},expression:"createForm.sales_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群组名称2","prop":"sales_name2","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"请输入（选填）","clearable":""},model:{value:(_vm.createForm.sales_name2),callback:function ($$v) {_vm.$set(_vm.createForm, "sales_name2", $$v)},expression:"createForm.sales_name2"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群组名称3","prop":"sales_name3","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"请输入（选填）","clearable":""},model:{value:(_vm.createForm.sales_name3),callback:function ($$v) {_vm.$set(_vm.createForm, "sales_name3", $$v)},expression:"createForm.sales_name3"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群组名称4","prop":"sales_name4","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"请输入（选填）","clearable":""},model:{value:(_vm.createForm.sales_name4),callback:function ($$v) {_vm.$set(_vm.createForm, "sales_name4", $$v)},expression:"createForm.sales_name4"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群组名称5","prop":"sales_name5","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"请输入（选填）","clearable":""},model:{value:(_vm.createForm.sales_name5),callback:function ($$v) {_vm.$set(_vm.createForm, "sales_name5", $$v)},expression:"createForm.sales_name5"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"default"},on:{"click":function($event){return _vm.resetForm('createForm')}}},[_vm._v("重置")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.submitForm('createForm')}}},[_vm._v("保存")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/group-batch-market-table.31e02872ecc382b37d40.js